import { memo } from 'react';
import type { ReactElement } from 'react';
import { clsx } from 'clsx';
import type { TableBodyProps } from './TableBody';
import type { TableHeaderProps } from './TableHeader';
import styles from './Table.module.scss';

const Table = ({
    children,
    striped,
    stripedReversed,
    loading,
    compact,
}: {
    /**
     * Alternate between transparent and light background colors
     * for rows
     */
    striped?: boolean;
    /**
     * Combine it with dark header
     */
    stripedReversed?: boolean;
    /**
     * Loading state for table data
     */
    loading?: boolean;
    /**
     * The compact style of table
     */
    compact?: boolean;
    children?:
        | ReactElement<TableBodyProps>[]
        | ReactElement<TableBodyProps>
        | ReactElement<TableHeaderProps>[]
        | ReactElement<TableHeaderProps>;
}) => {
    return (
        <table
            className={clsx(styles.table, {
                [styles.striped]: striped,
                [styles.stripedReversed]: stripedReversed,
                [styles.loading]: loading,
                [styles.compact]: compact,
            })}
        >
            {children}
        </table>
    );
};

export default memo(Table);
